import { useContext } from 'react';
import { createContext } from 'react';

export const SubmenuContext = createContext<any>({} as any);

SubmenuContext.displayName = 'Submenu';

const SubmenuProvider = (props: any) => (
	<SubmenuContext.Provider value={props}>{props.children}</SubmenuContext.Provider>
);

export const useSubmenu = () => {
	const context = useContext(SubmenuContext);

	return context;
};

export default SubmenuProvider;
